// /src/data/lessons/phase4_4-5/index.js
import q1 from './quarter1.js';
import q2 from './quarter2.js';
import q3 from './quarter3.js';
import q4 from './quarter4.js';

// Handle both array exports and object exports safely
const getQuarterLessons = (quarter) => {
  let lessons;
  // If it's already an array, use it
  if (Array.isArray(quarter)) lessons = quarter;
  // If it's an object with lessons property, use lessons
  else if (quarter?.lessons && Array.isArray(quarter.lessons)) lessons = quarter.lessons;
  // If it's null/undefined or empty, return empty array
  else return [];

  // Flatten in case lessons are wrapped in sub-arrays (e.g. [[L1,L2],[L3,L4]])
  return lessons.flat();
};

const allLessons = [
  ...getQuarterLessons(q1),
  ...getQuarterLessons(q2),
  ...getQuarterLessons(q3),
  ...getQuarterLessons(q4)
];

export default {
  phase: '4-5',  // Change this to '2-3', '3-4', '4-5' for other phases
  lessons: allLessons,
  total: 260
};